const AlertModalV2Reducer = (state, action) => {
    switch (action.type) {
        case "SUCCESS_CLOSE":
            return {
                ...state,
                textArray: action.textArray,
                type: action.type,
                okText: "Close",
                buttonNumber: 1,
            };
        case "okText":
            return { ...state, okText: action.okText };
        case "open":
            return {
                ...state,
                textArray: action.textArray,
                buttonNumber: action.buttonNumber,
                show: true,
            };
        case "openYes&No":
            return {
                ...state,
                textArray: action.textArray,
                buttonNumber: 2,
                show: true,
                okText: "Yes",
                cancelText: "No",
            };
        case "twoOptions":
            return {
                ...state,
                textArray: action.textArray,
                buttonNumber: 2,
                show: true,
                okText: action.okText,
                cancelText: action.cancelText,
            };
        case "processing":
            return {
                ...state,
                textArray: action.textArray,
                buttonNumber: 0,
                show: true,
            };
        case "cancelText":
            return { ...state, cancelText: action.cancelText };
        case "textKind":
            return { ...state, textKind: action.textKind };
        case "textArray":
            return { ...state, textArray: action.textArray };
        case "show":
            return { ...state, show: action.show };
        case "showAndText":
            return {
                ...state,
                show: true,
                textArray: action.textArray,
                buttonNumber: 1,
            };
        case "closeText":
            return {
                ...state,
                show: true,
                textArray: action.textArray,
                buttonNumber: 1,
                okText: "Close",
            };
        case "buttonNumber":
            return { ...state, buttonNumber: action.buttonNumber };
        case "success":
            return { ...state, textArray: action.textArray, buttonNumber: 1 };
        case "error":
            return { ...state, textArray: action.textArray, buttonNumber: 1 };
        case "closeModal":
            return { ...state, show: false, textArray: [], buttonNumber: 1 };
        case "title":
            return { ...state, title: action.title };
        default:
            return state;
    }
};

export default AlertModalV2Reducer;
